import { Trans } from '@lingui/react/macro';
import type { Integration } from 'src/api/endpoints/cloudApi.types';
import type { useGetIntegrationReauthURI } from 'src/api/queries';
import { useIntegrationProviders } from 'src/api/queries';
import { Button } from 'src/components';

export const ReAuthorizeIntegrationButton = ({
  integration,
  getIntegrationReauthURIMutation,
  dataCy,
}: {
  integration: Integration;
  getIntegrationReauthURIMutation: ReturnType<
    typeof useGetIntegrationReauthURI
  >;
  dataCy: string;
}) => {
  const providers = useIntegrationProviders();

  if (providers.isPending) return null;

  const provider = providers.data?.find(
    (provider) => provider.typeName === integration.provider
  );

  if (!provider) return null;

  const onSubmit = () => {
    getIntegrationReauthURIMutation.mutate(
      { providerPath: provider.subPath, integrationId: integration.id },
      {
        onSuccess: (authUrl) => {
          // External url to integration provider auth
          window.location.href = authUrl;
        },
      }
    );
  };

  return (
    <Button
      loading={getIntegrationReauthURIMutation.isPending}
      onClick={onSubmit}
      data-cy={dataCy}
      variant="secondary"
      size="small"
      mobileFullWidth
    >
      <span className="text-center">
        <Trans>Renew access</Trans>
      </span>
    </Button>
  );
};
